import React from 'react';
import './RippleLoader.css'
const Loader = ({ relative, inherit, center, position }) => <div style={{ left: center ? '50%' : 'inherit', top: center ? '50%' : 'inherit', position: position ? position : relative ? 'relative' : 'fixed' }} class="lds-ripple"><div></div><div></div></div>
export default Loader;
